import Vue from 'vue';
import moment, { isMoment, Moment } from 'moment';

const DATE_FORMAT = 'DD.MM.YYYY';
const TIME_FORMAT = 'HH:mm';
const DATE_TIME_FORMAT = 'DD.MM.YYYY HH:mm';

const weekdayTranslation : { [key: number]: string } = {
  1: 'Montag',
  2: 'Dienstag',
  3: 'Mittwoch',
  4: 'Donnerstag',
  5: 'Freitag',
  6: 'Samstag',
  7: 'Sonntag',
};


export function formatDate(date: Moment | string): string {
  const dateToFormat = isMoment(date) ? date : moment(date);
  return dateToFormat.format(DATE_FORMAT);
}

export function formatTime(time: Moment | string): string {
  const timeToFormat = isMoment(time) ? time : moment(time);
  return timeToFormat.format(TIME_FORMAT);
}

export function formatDateTime(time: Moment | string): string {
  const timeToFormat = isMoment(time) ? time : moment(time);
  return timeToFormat.format(DATE_TIME_FORMAT);
}

export function translatedWeekday(date: Moment | string): string {
  const dateToFormat = isMoment(date) ? date : moment(date);
  return weekdayTranslation[dateToFormat.isoWeekday()];
}

Vue.filter('formatDate', formatDate);
Vue.filter('formatTime', formatTime);
Vue.filter('formatDateTime', formatDateTime);
Vue.filter('translatedWeekday', translatedWeekday);
